import AdditionalServicesBookingAgreement from 'components/AdditionalServices/AdditionalServicesBookingAgreement'
import { FC } from 'react'
import { UserProtectedRoute } from 'routes'

const AdditionalServicesBookingAgreementPage: FC = () => {
  return (
    <UserProtectedRoute>
      <AdditionalServicesBookingAgreement />
    </UserProtectedRoute>
  )
}

export default AdditionalServicesBookingAgreementPage
